module.exports = __webpack_public_path__ + "prod/1.42.2/img/select-icons-4.19b397eb.svg";